import { Button } from 'react-bootstrap';
import { FaSpinner } from 'react-icons/fa';
import * as React from 'react';

interface RenewalSubmitButtonProps {
  isLoading: boolean;
  onSubmit?: () => any;
  disabled?: boolean;
}

export const RenewalSubmitButton = ({ isLoading, onSubmit, disabled }: RenewalSubmitButtonProps) => {

  if (onSubmit) {
    return (
      <>
        <Button
          bsStyle="primary"
          type="button"
          className="medium-width block secondary-button"
          disabled={isLoading || disabled}
          onClick={onSubmit}
        >
          {isLoading && (
            <FaSpinner className="fa-spin"/>
          )}
          APPLY CHANGES
        </Button>
      </>
    )
  }

  return (
    <>
      <Button
        bsStyle="primary"
        type="submit"
        className="medium-width block secondary-button"
        disabled={isLoading || disabled}
      >
        {isLoading && (
          <FaSpinner className="fa-spin"/>
        )}
        APPLY CHANGES
      </Button>
    </>
  )

}
